import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { UploadSteps } from "./UploadSteps";

import { UploadDataProvider } from "../uploadDataContext";
import { UploadFileStep } from "../types";

export const UploadData: FC = () => {
  const { t } = useTranslation("common");

  return (
    <UploadDataProvider data={{ step: UploadFileStep.Files, nextText: t("actions.next") }}>
      <UploadSteps />
    </UploadDataProvider>
  );
};
